import { TuiComboBoxModule, TuiFilterByInputPipeModule } from '@taiga-ui/kit';
import { TuiDataListModule, TuiScrollbarModule, TuiTextfieldControllerModule } from '@taiga-ui/core';
import { TuiLetModule } from '@taiga-ui/cdk';
import { TranslateModule } from '@ngx-translate/core';
import { SupplierInputComponent } from '@iss/libs/suppliers';
import { Supplier } from '@iss/libs/graphql';
import { FormControl, FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { Component, Inject, Self } from '@angular/core';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';

import {
  Control,
  ControlStatusDirective,
  FormFieldComponent,
  FormFieldErrorDirective,
  LabelDirective,
  NOOP_VALUE_ACCESSOR,
} from '@iss/core/forms';

@Component({
  selector: 'wo-supplier-filter-selector',
  templateUrl: './supplier-filter-selector.component.html',
  standalone: true,
  imports: [
    FormFieldComponent,
    LabelDirective,
    FormsModule,
    ReactiveFormsModule,
    ControlStatusDirective,
    FormFieldErrorDirective,
    NgIf,
    AsyncPipe,
    TranslateModule,
    TuiComboBoxModule,
    TuiLetModule,
    TuiTextfieldControllerModule,
    TuiFilterByInputPipeModule,
    TuiDataListModule,
    NgForOf,
    TuiScrollbarModule,
    SupplierInputComponent,
  ],
})
export class SupplierFilterSelectorComponent {
  public constructor(
    @Self() @Inject(NgControl) public readonly control: Control<FormControl<Supplier['id'] | null>>,
  ) {
    this.control.valueAccessor = NOOP_VALUE_ACCESSOR;
  }
}
